<template>
  <radio-form
    :name="fieldName"
    :validator="validator"
    :selectable-items="wishfulTimes"
    :label-id="fieldName"
    :label-template="labelTemplate"
    :dispatcher="dispatcher"
  />
</template>

<script setup>
import RadioForm from '@component_path/slide_form_common_module/components/form_element/Radio';
import {
  useWishfulTimeField,
  useWishfulTimeStore
} from '@component_path/inquiry_form_common_module/custom_hook/WishfulTime';

const props = defineProps({
  required: {
    type: Boolean,
    required: false,
    default: false
  },
  labelTemplate: {
    type: String,
    required: false
  }
});

const { validator, fieldName } = useWishfulTimeField(props.required);
const { wishfulTimes, dispatcher } = useWishfulTimeStore();
</script>
